import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import imgC1 from "../../assets/image/l5/png/l5-service-card1.svg";
import imgC2 from "../../assets/image/l5/png/l5-service-card2.svg";
import imgC3 from "../../assets/image/l5/png/l5-service-card3.svg";
import imgC4 from "../../assets/image/l5/png/l5-service-card4.svg";

import imgDot from "../../assets/image/l5/png/l5-dot-shape2.png";
import { Link } from "gatsby";

const Services = ({ data }) => {
  return (
    <>
      {/* <!--Service section  -->*/}
      <div
        id="our-services"
        className="service-section bg-default-4 pt-0 pb-13 py-lg-25"
      >
        <Container>
          <Row className="justify-content-center">
            <Col md="9" lg="7" xl="6">
              <div className="section-title text-center mb-11 mb-lg-19 px-lg-3">
                <h4 className="pre-title gr-text-12 text-red text-uppercase mb-7">
                  Our Services
                </h4>
                <h2 className="title gr-text-4">
                  Here’s What We Can Do For You
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center position-relative gr-z-index-1">

            {data.our_services.map((item, index) => {
              return (
                <Col
                  md="6"
                  lg="3"
                  className="mb-9 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="750"
                >
                  <div className="service-card rounded-10 gr-hover-shadow-4 d-flex flex-column text-center pt-15 px-9 pb-11 dark-mode-texts bg-purple h-100">
                    <div className="card-img mb-11">
                      <img src={item.service_image.url} className="w-100" alt={item.service_image.alt} />
                    </div>
                    <h3 className="card-title gr-text-6 mb-6">
                      {item.service_title.text}{" "}
                    </h3>
                    <p className="gr-text-9 mb-11">
                      {item.service_copy.text}
                    </p>
                    <Link
                      to="/#enquire-now"
                      className="gr-text-9 btn-link with-icon text-white mt-auto"
                    >
                      Enquire Now{" "}
                      <i className="icon icon-tail-right font-weight-bold"></i>
                    </Link>
                  </div>
                </Col>)
            })}




          </Row>
        </Container>
      </div>
    </>
  );
};

export default Services;
